import {
  symbol as d3Symbol,
  symbolCircle,
  symbolCross,
  timeMinute as d3TimeMinute,
  timeHour as d3TimeHour,
  timeDay as d3TimeDay,
  timeMonth as d3TimeMonth,
  timeWeek as d3TimeWeek,
  timeYear as d3TimeYear,
} from 'd3'

const multiTimeFormat = (intl, formatters, date) => {
  const formatterSelector = [
    /*
    {
      predicate: date => d3TimeSecond(date) < date,
      format: formatters.millis,
    },
    */
    {
      predicate: date => d3TimeMinute(date) < date,
      format: formatters.second,
    },
    {
      predicate: date => d3TimeHour(date) < date,
      format: formatters.minute,
    },
    {
      predicate: date => d3TimeDay(date) < date,
      format: formatters.hour,
    },
    {
      predicate: date => d3TimeWeek(date) < date,
      format: formatters.day,
    },
    {
      predicate: date => d3TimeMonth(date) < date,
      format: formatters.week,
    },
    {
      predicate: date => d3TimeYear(date) < date,
      format: formatters.month,
    },
    {
      predicate: () => true,
      format: formatters.year,
    },
  ]
  return formatterSelector.find(f => f.predicate(date)).format(date)
}

/**
 * Common time formatters for chart X axis and timeline
 */
const commonFormatters = intl => ({
  second: date =>
    intl.formatTime(date, {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    }),
  minute: date =>
    intl.formatDate(date, {
      hour: 'numeric',
      minute: 'numeric',
    }),
  hour: date =>
    intl.formatDate(date, {
      hour: 'numeric',
      minute: 'numeric',
    }),
})

/**
 * Area occupied by a point, in square pixels
 * @type {number}
 */
export const pointSymbolSize = 32

export const pointSymbols = {
  R: d3Symbol()
    .size(pointSymbolSize)
    .type(symbolCircle),
  I: d3Symbol()
    .size(pointSymbolSize * 2)
    .type(symbolCross),
}

export const defaultPointSymbol = pointSymbols.R

/**
 * Area occupied by a crosshair symbol, in square pixels
 * @type {number}
 */
export const crosshairSymbolSize = 64

export const crosshairSymbols = {
  R: d3Symbol()
    .size(crosshairSymbolSize)
    .type(symbolCircle),
  I: d3Symbol()
    .size(crosshairSymbolSize * 1.5)
    .type(symbolCross),
}

export const defaultCrosshairSymbol = crosshairSymbols.R

/**
 * Time format function for chart X axis
 * @param date
 * @return {string}
 */
export const xAxisTimeFormat = intl => date =>
  multiTimeFormat(
    intl,
    Object.assign(
      {
        day: date =>
          intl.formatDate(date, {
            month: 'short',
            day: 'numeric',
          }),
        week: date =>
          intl.formatDate(date, {
            month: 'short',
            day: 'numeric',
          }),
        month: date =>
          intl.formatDate(date, {
            month: 'long',
            day: 'numeric',
          }),
        year: date =>
          intl.formatDate(date, {
            year: 'numeric',
          }),
      },
      commonFormatters(intl)
    ),
    date
  )

/**
 * Time format function for timeline
 * @param date
 * @return {string}
 */
export const timelineTimeFormat = intl => date =>
  multiTimeFormat(
    intl,
    Object.assign(
      {
        day: date =>
          intl.formatDate(date, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          }),
        week: date =>
          intl.formatDate(date, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          }),
        month: date =>
          intl.formatDate(date, {
            year: 'numeric',
            month: 'long',
          }),
        year: date =>
          intl.formatDate(date, {
            year: 'numeric',
          }),
      },
      commonFormatters(intl)
    ),
    date
  )
